/**
 * Centralized business / brand configuration for Liz Luxes Services Cleaning LLC.
 * All hard-coded brand details should pull from here.
 */

export const siteConfig = {
  name: "Liz Luxes Services Cleaning LLC",
  shortName: "Liz Luxes Cleaning",
  legalName: "Liz Luxes Services Cleaning LLC",
  owner: "Lisset Gonzalez",
  tagline: "Luxury-Level Cleaning in Orange Park & Greater Jacksonville",
  description:
    "Professional cleaning company based in Orange Park, FL serving homes, offices, clinics, Airbnbs, and commercial spaces across Clay, Duval, and St. Johns counties. Deep cleaning, recurring service, move in/out cleaning, laundry, and closet organization — open 7 days a week.",

  domain: "lizluxesservicescleaningllc.com",
  url: "https://lizluxesservicescleaningllc.com",

  phone: "(904) 600-6466",
  phoneHref: "tel:+19046006466",
  smsHref: "sms:+19046006466",

  email: "lissetgonzalezf70@gmail.com",
  emailHref: "mailto:lissetgonzalezf70@gmail.com",

  address: {
    street: "540 George Watson St",
    city: "Orange Park",
    state: "FL",
    postalCode: "32073",
    country: "US",
    region: "Clay County",
    serviceRadius: "20 miles",
    full: "540 George Watson St, Orange Park, FL 32073",
  },

  hours: {
    summary: "Open 7 Days · 7 AM – 9 PM",
    days: "Monday – Sunday",
    time: "7:00 AM – 9:00 PM",
    opens: "07:00",
    closes: "21:00",
  },

  /** Tight-cropped mark used in the header, footer, and favicon. */
  logo: "/liz-luxes-logo.png",
  /** Full-width lockup — better proportions for social share cards. */
  ogImage: "/liz-luxes-og.png",
  favicon: "/liz-luxes-logo.png",

  social: {
    instagram: null,
    facebook: null,
    tiktok: null,
    yelp: null,
    bbb: null,
  },

  discount: {
    label: "Recurring & Referral Discounts",
    short: "Repeat Customer Discounts",
    description:
      "Returning customers and referrals receive a discount on every visit. The exact amount depends on the size of the job and your service area — just ask when you request your estimate.",
  },

  /**
   * Third-party widget IDs for the Liz Luxes LeadConnector / Reputation Hub account.
   * Set any of these to null to fall back to the site's native equivalent
   * (a mailto-based estimate form; the reviews section hides itself).
   */
  widgets: {
    chatWidgetId: "6a760fa446dfe9c546b667eb" as string | null,
    chatLoaderSrc: "https://widgets.leadconnectorhq.com/loader.js",
    chatResourcesUrl: "https://widgets.leadconnectorhq.com/chat-widget/loader.js",

    reviewScriptSrc: "https://reputationhub.site/reputation/assets/review-widget.js",
    reviewIframeSrc:
      "https://reputationhub.site/reputation/widgets/review_widget/A7JA6MaUDu509nJ8jgQO?widgetId=6a7ca611cdd7b264d8826120" as
        | string
        | null,

    formIframeSrc: "https://link.systemic-digital.net/widget/form/M5F4x1WSNvbFNKd4O70K" as
      | string
      | null,
    formScriptSrc: "https://link.systemic-digital.net/js/form_embed.js",
    formId: "M5F4x1WSNvbFNKd4O70K" as string | null,
    formName: "Website Form",
    /** Native height of the embedded form; form_embed.js resizes from here. */
    formHeight: 697,
  },

  serviceAreas: [
    "Orange Park, FL",
    "Fleming Island, FL",
    "Oakleaf Plantation, FL",
    "Middleburg, FL",
    "Green Cove Springs, FL",
    "Doctors Inlet, FL",
    "Lakeside, FL",
    "Bellair-Meadowbrook Terrace, FL",
    "Jacksonville, FL",
    "Mandarin, FL",
    "Ortega, FL",
    "Riverside-Avondale, FL",
    "San Marco, FL",
    "Argyle Forest, FL",
    "Fruit Cove, FL",
    "Julington Creek, FL",
    "St. Johns, FL",
    "Switzerland, FL",
    "St. Augustine, FL",
    "Fernandina Beach, FL",
  ],
} as const;

export type SiteConfig = typeof siteConfig;
